module.exports = __webpack_public_path__ + "ce193c0526621f017cb0ede9fdc24f69.png";


//////////////////
// WEBPACK FOOTER
// ./directives/footer/zipreports_logo.png
// module id = 256
// module chunks = 0